// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.evaluation-form__title {
  font-family: var(--default-font-family);
  font-size: 1.4rem;
}
.evaluation-form__section {
  margin-bottom: 2rem;
}
.evaluation-form__section .ant-form-item .ant-form-item-label {
  font-family: var(--default-font-family);
}
.evaluation-form__loader {
  height: 10rem;
  display: flex;
  justify-content: center;
}
.evaluation-form__submit {
  font-family: var(--default-font-family);
}
.evaluation-form__countdown.hide {
  opacity: 0;
}
.evaluation-form-single-question {
  margin-bottom: 1rem;
  margin-top: 1rem;
}

.checkbox-button-group {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.checkbox-button.ant-radio-wrapper,
.checkbox-button.ant-checkbox-wrapper {
  display: inline-flex;
  align-items: center;
  margin-inline-start: 0;
  margin-inline-end: 8px;
}
.checkbox-button.ant-radio-wrapper .ant-radio,
.checkbox-button.ant-radio-wrapper .ant-checkbox,
.checkbox-button.ant-checkbox-wrapper .ant-radio,
.checkbox-button.ant-checkbox-wrapper .ant-checkbox {
  display: none;
}
.checkbox-button.ant-radio-wrapper span:last-child,
.checkbox-button.ant-checkbox-wrapper span:last-child {
  display: inline-flex;
  align-items: center;
  padding: 6px 18px;
  border: 1.5px solid #d9d9d9;
  border-radius: 20px;
  background: #fff;
  cursor: pointer;
  font-size: 0.9rem;
  line-height: 1.4;
  transition: border-color 0.2s, background 0.2s, color 0.2s;
  user-select: none;
}
.checkbox-button.ant-radio-wrapper span:last-child:hover,
.checkbox-button.ant-checkbox-wrapper span:last-child:hover {
  border-color: var(--primary-color);
  color: var(--primary-color);
}
.checkbox-button.ant-radio-wrapper.ant-radio-wrapper-checked span:last-child, .checkbox-button.ant-radio-wrapper.ant-checkbox-wrapper-checked span:last-child,
.checkbox-button.ant-checkbox-wrapper.ant-radio-wrapper-checked span:last-child,
.checkbox-button.ant-checkbox-wrapper.ant-checkbox-wrapper-checked span:last-child {
  background: var(--primary-color);
  border-color: var(--primary-color);
  color: #fff;
}
.checkbox-button.ant-radio-wrapper.ant-radio-wrapper-disabled span:last-child, .checkbox-button.ant-radio-wrapper.ant-checkbox-wrapper-disabled span:last-child,
.checkbox-button.ant-checkbox-wrapper.ant-radio-wrapper-disabled span:last-child,
.checkbox-button.ant-checkbox-wrapper.ant-checkbox-wrapper-disabled span:last-child {
  opacity: 0.5;
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/components/ui/EvaluationForm/EvaluationForm.scss"],"names":[],"mappings":"AACI;EACI,uCAAA;EAEA,iBAAA;AADR;AAII;EACI,mBAAA;AAFR;AAKY;EACI,uCAAA;AAHhB;AAQI;EACI,aAAA;EACA,aAAA;EACA,uBAAA;AANR;AASI;EACI,uCAAA;AAPR;AAWQ;EACI,UAAA;AATZ;AAaI;EACI,mBAAA;EACA,gBAAA;AAXR;;AAeA;EACI,aAAA;EACA,eAAA;EACA,QAAA;AAZJ;;AAeA;;EAEI,oBAAA;EACA,mBAAA;EACA,sBAAA;EACA,sBAAA;AAZJ;AAcI;;;;EAEI,aAAA;AAVR;AAaI;;EACI,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,2BAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,0DAAA;EACA,iBAAA;AAVR;AAYQ;;EACI,kCAAA;EACA,2BAAA;AATZ;AAaI;;;EAEI,gCAAA;EACA,kCAAA;EACA,WAAA;AAVR;AAaI;;;EAEI,YAAA;EACA,mBAAA;AAVR","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
